(function () {
  var IMAGE_SELECTOR = '.product-card-image, .featured-image, .collection-card--image, .gallery--item';

  function visibleSlides(scroll) {
    return Array.prototype.filter.call(scroll.querySelectorAll('.carousel__slide'), function (slide) {
      return slide.offsetWidth > 0 && slide.offsetHeight > 0;
    });
  }

  function positionArrows(scroll) {
    if (!scroll.classList.contains('has-arrows')) return;

    var prev = scroll.querySelector('.flickity-prev');
    var next = scroll.querySelector('.flickity-next');
    if (!prev || !next) return;

    var slides = visibleSlides(scroll);
    if (!slides.length) return;

    if (!scroll.nav && typeof scroll.init === 'function') {
      scroll.init();
    }

    var image = slides[0].querySelector(IMAGE_SELECTOR);
    var imageHeight = image ? image.clientHeight : 0;
    var maxHeight = 0;
    slides.forEach(function (slide) {
      if (slide.clientHeight > maxHeight) maxHeight = slide.clientHeight;
    });

    if (imageHeight > 0 && maxHeight > imageHeight) {
      var difference = (maxHeight - imageHeight) / -2;
      var transform = 'translateY(' + difference + 'px)';
      prev.style.transform = transform;
      next.style.transform = transform;
    }

    var viewport = scroll.querySelector('.theme-scroll--inner');
    var noOverflow = !viewport || viewport.scrollWidth <= viewport.clientWidth + 2;
    scroll.classList.toggle('arrows-no-overflow', noOverflow);
  }

  function refreshAll() {
    document.querySelectorAll('theme-scroll.has-arrows').forEach(positionArrows);
  }

  var timer;
  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(refreshAll, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }

  window.addEventListener('load', refreshAll);
  window.addEventListener('resize', schedule);

  document.addEventListener('click', function (event) {
    if (event.target.closest('.collection-tabs__list-link')) schedule();
  });

  if (window.MutationObserver) {
    var startObserver = function () {
      if (!document.body) return;
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
            schedule();
            return;
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    };

    if (document.body) startObserver();
    else document.addEventListener('DOMContentLoaded', startObserver);
  }
})();
